module.exports = __webpack_public_path__ + "img/product_96.a79b940.svg";